import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import QuarterlyReport from 'src/entities/QuarterlyReport';

export interface ApiQuarterlyReportResponse {
  id: number;
  title?: string;
  year: number;
  quarter: string;
  url: string;
  imageUrl: string;
}

interface ApiQuarterlyReportCreateRequest {
}

export class QuarterlyReportFactory extends BaseFactory<QuarterlyReport> {
  public toEntity(args: ApiQuarterlyReportResponse): QuarterlyReport {
    return new QuarterlyReport({
      id: args.id,
      title: args.title,
      year: args.year,
      quarter: args.quarter,
      url: args.url,
      imageUrl: args.imageUrl,
    });
  }

  public toRequest(quarterlyReport: QuarterlyReport): ApiQuarterlyReportCreateRequest {
    return {};
  }
}


// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/QuarterlyReportFactory.tsx